import React from "react"
import Layout from "../components/_App/layout"
import Seo from "../components/_App/seo"
import Navbar from "../components/_App/Navbar"
import PageBanner from "../components/Common/PageBanner"
import OurHistory3 from "../components/AboutUs/OurHistory3"
import TeamMember from "../components/Index/TeamMember" 

import Footer from "../components/_App/CompanyFooter"

const FAQPage = () => {
  return (
    <Layout>

      <Navbar />

      <PageBanner
        pageTitle="Company"
      />

      <OurHistory3 />

      <TeamMember />

      <Footer />

    </Layout>
  )
}

export const Head = () => <Seo title="FAQ" />

export default FAQPage
